import LanguageSelectClient from './clients/LanguageSelectClient';

class LanguageSelector
{
    constructor()
    {
        this.ttl = 2592000;  // 30 days
        this.languageSelectClient = new LanguageSelectClient();
        this.customerIdMetaData = document.querySelector('meta[name="customer_id"]');
        this.elements = document.querySelectorAll('.js-new-language-selection');
    }

    init()
    {
        this.elements.forEach(element =>
        {
            element.addEventListener('click', (e) =>
            {
                e.preventDefault();
                this.setCookie(element.dataset.language);
                let anchor = element.querySelector('a');

                this.customerIdMetaData !== null
                    ? this.selectLanguage(element.dataset.language, anchor.href)
                    : window.location.href = anchor.href;
            });
        });
    }

    selectLanguage(language, href)
    {
        this.languageSelectClient.selectLanguage(language)
            .finally(() =>
            {
                window.location.href = href;
            });
    }

    setCookie(language)
    {
        let options = {
            'expires': this.ttl,
            'secure': false,
        };

        Cookies.set('lastSelectedLanguage', language, options);
    }
}

const languageSelector = new LanguageSelector();
languageSelector.init();

